module.exports = __webpack_public_path__ + "img/arlogo-white.418681c3.png";